import React from "react";
import { sub_profile } from "assets/images/images";

const SubscriberInformationCard = ({ medicalUserDetail }) => {
  return (
    <div className="sp_subscriber_info_card">
      <div className="sp_avatar_container">
        <img src={sub_profile} alt="Profile" className="sp_profile_image" />
      </div>
      <div className="sp_subscriber_details">
        <h2 className="sp_subscriber_name">
          {medicalUserDetail?.firstname + " " + medicalUserDetail?.lastname}
        </h2>
        <p className="sp_account_number">{`Account #${medicalUserDetail?.account_no}`}</p>
        <p className="sp_status">
          Status:{" "}
          <span
            className={`sp_status_value ${
              medicalUserDetail?.is_subscription_cancelled
                ? "inactive"
                : "active"
            }`}
          >
            {medicalUserDetail?.is_subscription_cancelled
              ? "Inactive"
              : "Active"}
          </span>
        </p>
      </div>
    </div>
  );
};

export default SubscriberInformationCard;
